exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SettingPhoneSection .Wrap {\n  max-width: 480px;\n  width: 100%;\n  margin: 0 auto;\n  float: none; }\n\n.SettingPhoneSection .NavVertical__Link {\n  height: auto;\n  line-height: 24px;\n  margin: 0 0 16px 0; }\n\n.SettingPhoneSection .NavVertical__Icon {\n  padding: 0; }\n  .SettingPhoneSection .NavVertical__Icon svg {\n    width: 24px;\n    height: 24px; }\n", ""]);

// exports
